import {IHttpService} from "angular";
import {OffsetDateTime} from "../../../pseudo-types/DateTypes";
import {NewsHeadlineRecords} from "../../models/NewsHeadlineRecord";
import {Securities} from "../../../instruments/types/CodeAndExchange";
import {NewsHistoryRequest} from "../../types/NewsHistoryRequest";
import {NewsItemId} from "../../types/NewsItemId";
import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {FeatureNames} from "../../../types/UserConfig";
import {NewsSessionIdStore} from "../../store/news-id/NewsSessionIdStore";

const NewsSessionIdHeader = "x-zchar4";

export class NewsItemService {

    public static readonly id = "newsItemService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService,
                       private readonly currentUserService: CurrentUserService,
                       private readonly newsSessionIdStore: NewsSessionIdStore) {
    }

    public async headlinesSince(since: OffsetDateTime): Promise<NewsHeadlineRecords> {
        if (this.currentUserService.hasFeature(FeatureNames.NEWS)) {
            const url = `/tradefloor/api/news/headlines`;
            const params = {since};
            const config = {
                ignoreLoadingBar: true,
                params
            };
            const response = await this.$http.get<NewsHeadlineRecords>(url, config);
            const idHeader = response.headers(NewsSessionIdHeader);
            if (idHeader != null) {
                this.newsSessionIdStore.update(idHeader);
            }
            return response.data;
        } else {
            return [];
        }
    }

    public async headlineHistory(securities: Securities | null,
                                 from: OffsetDateTime,
                                 targetItems: number): Promise<NewsHeadlineRecords> {
        if (this.currentUserService.hasFeature(FeatureNames.NEWS)) {
            const url = "/tradefloor/api/news/history";
            const request: NewsHistoryRequest = {
                securities,
                from,
                targetItems
            };
            const response = await this.$http.post<NewsHeadlineRecords>(url, request, {ignoreLoadingBar: true});
            const idHeader = response.headers(NewsSessionIdHeader);
            if (idHeader != null) {
                this.newsSessionIdStore.update(idHeader);
            }
            return response.data;
        } else {
            return [];
        }
    }

    public async story(id: NewsItemId): Promise<string | null> {
        if (this.currentUserService.hasFeature(FeatureNames.NEWS)) {
            const url = `/tradefloor/api/news/${id}`;
            const response = await this.$http.get<string | null>(url);
            return response.data;
        } else {
            return null;
        }
    }
}
